/**
 * Turn-by-turn handoff to Google Maps (ADR-007) — identical on web and inside the
 * Capacitor shell. This is a plain `https://` URL, not a custom `geo:`/`comgooglemaps://`
 * scheme: Android and iOS both intercept a Google Maps web link and offer to open it in
 * the installed app, so one URL format covers both platforms and degrades to the Maps
 * website if the app is missing rather than doing nothing.
 */
export function googleMapsDirectionsUrl(destination: {
  latitude: number
  longitude: number
}): string {
  const params = new URLSearchParams({
    api: '1',
    destination: `${destination.latitude},${destination.longitude}`,
  })
  return `https://www.google.com/maps/dir/?${params.toString()}`
}

/** Opens the handoff URL in a new tab (web) or the system browser (native shell). */
export function openDirections(destination: { latitude: number; longitude: number }): void {
  window.open(googleMapsDirectionsUrl(destination), '_blank', 'noopener')
}
